import { Box, Text, Flex, Progress, Tooltip } from "@chakra-ui/react";
import { fetchUserDetails } from "../../allApi/api";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setUserPlan,
  setUserPlanDetails,
} from "../../redux/reducer/userDetails";

const CreditsInfo = () => {
  const [remainingCredits, setRemainingCredits] = useState(0);
  const [totalCredits, setTotalCredits] = useState(0);

  const { runCount, userPlanDetails } = useSelector(
    (state) => state?.userDetails
  );

  const dispatch = useDispatch();

  const getUserData = async () => {
    try {
      const response = await fetchUserDetails();

      const userDetails = response?.user;
      if (!userDetails) return;

      const total = userDetails?.["plan details"]?.["credits/month"] || 0;
      const remaining = userDetails?.["credits/month"] || 0;

      setTotalCredits(total);
      setRemainingCredits(remaining);

      dispatch(setUserPlan(userDetails?.plan));

      if (!userPlanDetails) {
        dispatch(setUserPlanDetails(userDetails?.["plan details"]));
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const percent =
  totalCredits === -1
    ? 100
    : totalCredits > 0
    ? (remainingCredits / totalCredits) * 100
    : 0;

  useEffect(() => {
    getUserData();
  }, [runCount]);

  return (
    <Box
      w={"100%"}
      margin={"auto"}
      p={1}
      bg="#232627"
      mt={1}
      mb={1}
      borderRadius="md"
      boxShadow="sm"
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontSize="xs" fontWeight="semibold" color="gray.200">
          Credits
        </Text>

        <Text fontSize="10px" color="green.300">
          {remainingCredits?.toLocaleString()} left
        </Text>
      </Flex>

      <Tooltip
        fontSize={"10px"}
        label={`${remainingCredits?.toLocaleString()} / ${totalCredits?.toLocaleString()} credits`}
      >
        <Progress
          value={percent}
          size="xs"
          colorScheme="green"
          borderRadius="md"
          bg="gray.600"
        />
      </Tooltip>
    </Box>
  );
};

export default CreditsInfo;